export const TENANT_ID = 'ptth-harvard-pilgrim';
export const APP_ID = 'ptth-harvard-pilgrim-web';

export const MASONRY = {
  ROOT_NODE_ID_HOME_PAGE: 'homePage$root', // TODO: Replace with tenant-specific masonry node id
  ROOT_NODE_ID_SUPPORT_PAGE: 'support$root',
  ROOT_NODE_ID_BEHAVIORAL_HEALTH_PAGE: 'behavioralHealthPage$root',
};
